<div class="dashboard-layout">
  <!-- Sidebar -->
  <aside class="sidebar">
    <div class="sidebar-logo">
      <img src="assets/logo.png" alt="Heart Institute Logo" />
    </div>

    <hr class="sidebar-divider" />

    <nav class="sidebar-menu">
      <ul>
        <li>
          <a routerLink="/dashboard" routerLinkActive="active-link">
            <i data-feather="layout"></i>
            <span>Dashboard</span>
          </a>
        </li>
        <li>
          <a routerLink="/workflow" routerLinkActive="active-link">
            <i data-feather="git-branch"></i>
            <span>Workflow</span>
          </a>
        </li>
        <li>
          <a routerLink="/data-catalogue" routerLinkActive="active-link">
            <i data-feather="database"></i>
            <span>Data Catalogue</span>
          </a>
        </li>
      </ul>
    </nav>
  </aside>

  <!-- Main Content -->
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>